module.exports = "* {\n  color: #f00; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pagenotfound/pagenotfound.component.scss
// module id = 433
// module chunks = 0